import moment from 'moment';

const presets = {
	currentMonth: function getCurrentMonthDateRange () {
		let start = moment().startOf('month').toDate();
		let end = moment().endOf('day').toDate();
		return [start, end];
	},
	lastmonth: function getLastMonthDateRange () {
		let start = moment().subtract(1, 'months').startOf('month').toDate();
		let end = moment().subtract(1, 'months').endOf('month').toDate();
		return [start, end];
	},
	last90: function getLast90DaysDateRange () {
		let start = moment().subtract(90, 'days').toDate();
		let end = moment().toDate();
		return [start, end];
	},
	ytd: function getYearToDateDateRange () {
		let start = moment().startOf('year').toDate();
		let end = moment().toDate();
		return [start, end];
	},
	lastyear: function getLastYearDateRange () {
		let start = moment().subtract(1, 'years').startOf('year').toDate();
		let end = moment().subtract(1, 'years').endOf('year').toDate();
		return [start, end];
	}
};

export default presets;



// WEBPACK FOOTER //
// ./widgets/datepickerPresets.es6